import { Head } from '@inertiajs/react';
import { MarketComingSoon } from '@/components/market/market-coming-soon';
import { MarketHeader } from '@/components/market/market-header';
import { MarketList } from '@/components/market/market-list';
import { MarketWelcome } from '@/components/market/market-welcome';
import type { MarketIndex } from '@/types';

export default function Index({
  edition,
  initialState,
  showWelcome,
  eventId,
  title,
  description,
}: MarketIndex) {
  if (!initialState) return <MarketComingSoon />;

  const list = (
    <MarketList initialData={initialState} hackSlug={edition.slug} />
  );

  return (
    <>
      {title && (
        <Head title={title}>
          {description && <meta name="description" content={description} />}
        </Head>
      )}
      <div className="mx-auto flex max-w-3xl flex-col gap-5 p-4 sm:p-6">
        <MarketHeader
          initialData={initialState}
          hackSlug={edition.slug}
          eventLabel={edition.eventLabel}
        />
        {showWelcome ? (
          <MarketWelcome
            initialBananas={initialState.market.initialBananas}
            feeBps={initialState.market.feeBps}
            minTradeBananas={initialState.market.minTradeBananas}
            eventId={eventId ?? ''}
          >
            {list}
          </MarketWelcome>
        ) : (
          list
        )}
      </div>
    </>
  );
}
